<template>
  <div class="stripes-bar">This item is archived</div>
</template>

<script>
export default {
  name: 'ArchivedBar'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.stripes-bar {
  background: repeating-linear-gradient(
    135deg,
    $stripeSecondary,
    $stripeSecondary 10px,
    $stripePrimary 10px,
    $stripePrimary 20px
  );
  padding: 2px 0;
  text-align: center;
}
</style>
